import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import {  NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ngx-token-login',
  templateUrl: './token-login.component.html',
})
export class TokenLoginComponent extends NbLoginComponent  {
  constructor(service: NbAuthService, @Inject(NB_AUTH_OPTIONS) protected options = {} , cd: ChangeDetectorRef, router: Router) {
    super(service, options, cd, router);
    this.user = {
      username: '',
      password: '',
      client_id: 'android-app' ,
      client_secret: 'dZnbRZq5d39gW8HH',
      grant_type: 'password',
      redirect_uri: '',
      // redirect_uri: 'http://localhost:4200/agt/employee/login-callback',
    };
  }
/*
  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
      } else {
        this.errors = result.getErrors();
      }

      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }*/
}
